<template>
  <section class="login">
    <h1>
      <img src="/img/logo.svg" width="96" height="96" alt="logo" />
      <span class="hubday-green">h</span>ub
      <span class="hubday-green">d</span>ay
    </h1>
    <div :class="{ 'guest' : guestMode }">
      <form method="POST" id="login-form">
        <div :class="{ 'oauth' : oauthMode }">
          <div class="input credentials">
            <label for="login">
              <i class="icon-user"></i>
              <input
                type="text"
                class="browser-default"
                name="login"
                id="login"
                placeholder="Identifiant"
                autocomplete="off"
                autofocus
                autocapitalize="none"
                required
                v-model="username"
                @keyup.enter="login()"
              />
            </label>
            <label for="password">
              <i class="icon-password"></i>
              <input
                type="password"
                class="browser-default"
                name="password"
                id="password"
                placeholder="Mot de passe"
                required
                v-model="password"
                @keyup.enter="login()"
              />
            </label>
          </div>
          <div class="gitlabLogin">
            <a class="login-btn cas-btn" :href="casAuthURI">
              <img src="/img/ub.svg" alt="Logo Université de Bordeaux" width="32" height="32" />Connexion via
              CAS
            </a>
            <a class="login-btn gitlab-btn" :href="gitlabAuthURI">
              <img src="/img/gitlab.svg" alt="Logo Gitlab" width="32" height="32" />Connexion via
              Gitlab
            </a>
            <br />Vous serez redirigé sur la page de connexion
            <br />Gitlab de l'IUT afin de valider votre identité
          </div>
        </div>
        <input type="checkbox" id="remember" name="remember" />
        <div class="rememberMe">
          <label>
            <input type="checkbox" class="filled-in" value="remember" v-model="rememberMe" />
            <span>Se souvenir de moi</span>
          </label>
        </div>
        <div class="toggleGitlab">
          <transition name="fade" mode="out-in">
            <span
              @click="toggleGitlabMode()"
              v-bind:key="oauthMode"
            >Me connecter grâce à {{ oauthMode ? 'un mot de passe' : 'CAS ou Gitlab' }}</span>
          </transition>
        </div>
      </form>
      <form method="POST" id="guest-form">
        <div class="select">
          <select class="browser-default" name="semester" id="semester-select" v-model="semester">
            <option value="default" disabled>- TON SEMESTRE -</option>
            <option value="S1">&lt; S1 /&gt;</option>
            <option value="S2">&lt; S2 /&gt;</option>
            <option value="S3">&lt; S3 /&gt;</option>
            <option value="S4">&lt; S4 /&gt;</option>
          </select>
          <div class="select_arrow"></div>
        </div>
        <div class="select">
          <select class="browser-default" name="group" id="group-select" v-model="group">
            <option value="default" disabled>- TA CLASSE -</option>
            <option value="A">&lt; A /&gt;</option>
            <option value="B">&lt; B /&gt;</option>
            <option value="C">&lt; C /&gt;</option>
            <option value="D">&lt; D /&gt;</option>
            <option value="robotic" v-if="semester == 'S4'">&lt; Robotique /&gt;</option>
          </select>
          <div class="select_arrow"></div>
        </div>
        <div class="select">
          <select class="browser-default" name="subgroup" id="subgroup-select" v-model="subgroup" :disabled="group == 'robotic'">
            <option value="default" disabled>- TON GROUPE -</option>
            <option value="prime">&lt; PRIME /&gt;</option>
            <option value="seconde">&lt; SECONDE /&gt;</option>
          </select>
          <div class="select_arrow"></div>
        </div>
      </form>
    </div>
    <p>
      <transition name="fade" mode="out-in">
        <button
          @click="toggleGuestMode()"
          v-bind:key="guestMode"
          class="btn waves-effect waves-light"
        >{{ guestMode ? 'Retour' : 'Invité' }}</button>
      </transition>
      <button
        class="btn waves-effect waves-light"
        type="submit"
        name="action"
        :class="{ 'hidden' : oauthMode & !guestMode }"
        :disabled="!((guestMode && semester != 'default' && group != 'default' && (subgroup != 'default' || group == 'robotic')) || (!guestMode && username.length > 0 && password.length > 0))"
        @click="login()"
      >Connexion</button>
    </p>
    <transition name="fade" mode="out-in">
      <h2 v-bind:key="result">{{ result }}</h2>
    </transition>
  </section>
</template>

<style scoped>
.select:first-child {
  margin-top: 0;
}

#login-form {
  overflow: hidden;
  height: 200px;
  opacity: 1;
  transition: height 0.3s, opacity 0.3s;
}

#guest-form {
  overflow: hidden;
  height: 0;
  opacity: 0;
  transition: height 0.3s, opacity 0.3s;
}

.guest #login-form {
  height: 0;
  opacity: 0;
}

.guest #guest-form {
  height: 200px;
  opacity: 1;
}

.gitlabLogin {
  overflow: hidden;
  height: 0;
  opacity: 0;
  transition: height 0.3s, opacity 0.3s;
}

.input.credentials {
  overflow: hidden;
  height: 100px;
  opacity: 1;
  transition: height 0.3s, opacity 0.3s;
}

.oauth .gitlabLogin {
  height: 100px;
  opacity: 1;
}

.oauth .input.credentials {
  height: 0;
  opacity: 0;
}



.toggleGitlab {
  padding: 16px 0;
}

.toggleGitlab span {
  font-family: "Poiret One";
  font-size: 16px;
  border-bottom: 1px dotted white;
  cursor: pointer;
  user-select: none;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.select {
  position: relative;
  display: block;
  width: 300px;
  margin: 20px auto;
}

.select select {
  display: inline-block;
  width: 100%;
  cursor: pointer;
  padding: 0 18px;
  outline: 0;
  border: 7px solid #afdab9;
  border-radius: 16px;
  background: #ffffff;
  color: #7b7b7b;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  height: 48px;
}

.select select::-ms-expand {
  display: none;
}

.select select:hover,
.select select:focus {
  color: #000000;
  background: #e0e0e0;
}

.select select:disabled {
  opacity: 0.3;
  pointer-events: none;
}

.select_arrow {
  position: absolute;
  top: 16px;
  right: 24px;
  width: 7px;
  height: 7px;
  border: solid #7b7b7b;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  pointer-events: none;
}

.select select:hover ~ .select_arrow,
.select select:focus ~ .select_arrow {
  border-color: #000000;
}

.select select:disabled ~ .select_arrow {
  border-top-color: #afdab9;
}

.login {
  min-height: 100%;
  height: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #222;
  color: white;
}

.login h1 {
  display: flex;
  align-items: center;
  font-size: 80px;
  font-weight: bold;
  font-family: "Poiret One";
}

.login h1 .hubday-green {
  color: #afdab9;
}

.login h2 {
  font-family: "Lato";
  min-height: 32px;
  padding: 0 16px;
}

.login .credentials label {
  background-color: #ffffff;
  display: flex;
  align-items: center;
  margin: 10px auto;
  width: 300px;
}

.login .credentials label i {
  color: #444;
  font-size: 28px;
  margin: 4px;
}

.login .credentials input {
  border: none;
  font-size: 18px;
  margin-top: 0px;
  width: 100%;
  font-family: "Lato";
}

.login input[type="text"]:focus,
.login input[type="password"]:focus {
  outline: none;
}

.login-btn {
  color: #fff;
  padding: 6px 14px;
  border: none;
  border-radius: 28px;
  text-decoration: none;
  display: inline-block;
  margin: auto;
  font-size: 19px;
  text-align: center;
  font-weight: bold;
  margin-bottom: 10px;
  display: block;
  width: 260px;
}

.login-btn.gitlab-btn {
    background-color: #fa7035;
}

.login-btn.cas-btn {
  background-color: #009DE0;
}

.login-btn img {
  max-width: 100%;
  vertical-align: -30%;
  margin-right: 10px;
}

.rememberMe {
  padding-top: 16px;
  font-family: "Poiret One";
}

.rememberMe [type="checkbox"] + span:not(.lever) {
  padding-left: 28px;
  color: white;
  font-size: 18px;
}

.gitlabLogin {
  font-family: "Poiret One";
}

/* Override Materialize */
.rememberMe [type="checkbox"].filled-in:checked + span:not(.lever):after {
  border: 2px solid #afdab9;
  background-color: #afdab9;
}

.btn,
.btn-large,
.btn-small {
  background-color: #afdab9;
  color: black;
  margin: 0 16px;
  width: 125px;
  border-radius: 0;
}

.btn.hidden {
    width: 0;
    padding: 0;
    margin: 0;
}
</style>

<script>
import axios from "axios";

export default {
  props: {
    gitlabAuthURI: {
      type: String,
      default: null,
    },
    casAuthURI: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      guestMode: false,
      oauthMode: false,
      semester: "default",
      group: "default",
      subgroup: "default",
      username: "",
      password: "",
      rememberMe: [],
      result: " ",
    };
  },
  methods: {
    toggleGuestMode() {
      this.guestMode = !this.guestMode;
    },
    toggleGitlabMode() {
      this.oauthMode = !this.oauthMode;
    },
    login() {
      if (
        (!this.guestMode &&
          this.username.length > 0 &&
          this.password.length > 0) ||
        this.guestMode
      ) {
        this.result = "Veuillez patienter...";
        if (this.guestMode) {
          axios
            .get(
              "https://www.hubday.fr/auth/api/login?mode=guest&group=" + (this.group != 'robotic' ? `${this.semester}${this.group}-${this.subgroup}` : 'roboticS4')
            )
            .then((response) => {
              var jsonResult = response["data"];
              if (jsonResult["status"] == "error") {
                this.result = "Erreur : " + jsonResult["message"];
              } else {
                this.result =
                  "Bienvenue " +
                  jsonResult["displayName"] +
                  ", nous vous connectons...";
                this.$store.dispatch(
                  "loginWithCustomToken",
                  jsonResult["token"]
                );
              }
            });
        } else if (!this.guestMode) {
          axios
            .post("https://www.hubday.fr/auth/api/login", {
              username: this.username,
              password: this.password,
            })
            .then((response) => {
              var jsonResult = response["data"];
              if (jsonResult["status"] == "error") {
                this.result = "Erreur : " + jsonResult["message"];
              } else {
                this.result =
                  "Bienvenue " +
                  jsonResult["displayName"] +
                  ", nous vous connectons...";
                this.$store.dispatch(
                  "loginWithCustomToken",
                  jsonResult["token"]
                );
              }
            });
        }
      }
    },
  },
};
</script>
